<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid p-0 m-0">
    <div class="row">

      <div class="col-4" v-if="fileUrl != null">
        <a v-bind:href="fileUrl" target="_blank"><span style="display:block;border:1px solid #ddd" v-html="getThumbNail"></span></a>
      </div>
      <div class="col-4" v-if="fileUrl == null">
        <!--nothing-->
      </div>
      <div class="col-8" v-if="fileUrl != null">
        <b>{{$t('name')}}:</b> {{fileName}} (<a v-bind:href="fileUrl" target="_blank">{{$t('link')}}</a>)
        <a v-if="showDelete" @click="deleteFile(fileId)" style="color: inherit"><i style="font-size: 16px; color: inherit" class="fa fa-trash-o"></i></a><br />
        <b>Type:</b> .{{fileExtension}}, ({{fileType}}) <br />
        <b>Created:</b> {{dateCreated}} {{timeCreated}}<br />
        <b>{{$t('filesize')}}:</b> {{size}}<br />
      </div>
      <div class="col-12 mt-1" v-if="fileUrl == null">
        {{fileName}}
      </div>
      <div class="container-fluid" v-show="showtrackchanges == true">
        <div class="row pt-2">
          <div class="col-12">
            <input-checkbox id="saveInLib" v-bind:text="$t('track_changes')" @input="setTrackChanges" v-bind:checked="trackChanges"></input-checkbox>
          </div>
        </div>
      </div>

      <!--<div class="container-fluid" v-show="showuserviews == true && trackChanges===true">
        <div class="row pt-2">
          <div class="col-12" v-if="userviews.length>0">
            {{$t('user_read_verification')}} {{ dateUpdated }}:
            <table class="table">
              <tr v-for="user in userviews" class="mt-1">
                <td align="left" style="padding-left:0px !important;">{{ user.user }}:{{ user.date }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>-->

    </div>
  </div>

</template>

<script>

  import UploadService from "../services/UploadFilesService";

  var fileName = null;
  var fileUrl = null;
  var fileExtension = null;
  var dateCreated = null;
  var timeCreated = null;
  var fileType = null;
  var size = null;
  var settings = null;
  var fileId = 0;
  export default {
    name: "upload-file-properties",
    components: {
      UploadService
    },
    props: {
      showDelete: {
        required: false,
        type: Boolean,
        default: false
      },
      showtrackchanges: {
        required: false,
        type: Boolean,
        default: false
      },
      showuserviews: {
        required: false,
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        fileName,
        fileUrl,
        fileExtension,
        dateCreated,
        timeCreated,
        fileType,
        size,
        settings,
        fileId,
        userviews: [],
        dateUpdated: '',
      };
    },
    methods: {
      getTrackChanges() {
        return this.trackChanges;
      },
      setTrackChanges(val) {
        this.trackChanges = val;
      },
      displayDefaultContent() {
        this.fileName = 'No file selected';
        this.fileUrl = null;
        this.fileExtension = null;
        this.dateCreated = null;
        this.timeCreated = null;
        this.fileType = null;
        this.size = null;
        this.trackChanges = false;
      },
      deleteFile(fileId) {
        this.$emit('delete_file', fileId);
      },
      loadFile(url, name, settings) {
        if (url != null) {
          var id = "";
          var urlParts = url.split('?');
          if (urlParts.length > 1) {
            var urlSegments = urlParts[1].split('&');
            id = urlSegments[0].split('=')[1];
            UploadService.getFileInfo(id, this.showuserviews).then((response) => {
              this.fileName = response.data.FileName;
              this.fileUrl = response.data.FileUrl;
              this.fileExtension = response.data.FileExtension;
              this.dateCreated = response.data.DateCreated;
              this.timeCreated = response.data.TimeCreated;
              this.fileType = response.data.FileType;
              this.size = response.data.Size;
              this.fileId = response.data.Id;
              this.trackChanges = response.data.TrackChanges;
              this.userviews = response.data.users;
              this.dateUpdated = response.data.updated;
              this.$forceUpdate();
            });
          }
          else {
            this.fileName = name;
            this.fileUrl = url;
            this.fileExtension = "-";
            this.dateCreated = "-";
            this.timeCreated = "-";
            this.fileType = "-";
            this.size = "-";
            this.userviews = [];
            this.dateUpdated = '';
          }

          this.settings = settings;

        }
        else {
          this.displayDefaultContent();
        }

      }
    }
    ,
    computed: {

      getThumbNail: {

        get() {
          var text = this.$t('no_image');
          if (this.fileType.indexOf('image') > -1) {
            return "<img alt='" + text + "' style='padding:10px;' src='" + this.fileUrl + "' width=100%>"
          }
          else
            return "<img alt='" + text + "' style='padding:10px' src='/Images/file_icons/" + this.fileExtension + ".png' width=100%>"
        }


      },
    },
    watch: {

    },
    mounted() {

    }
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/upload/upload-file-properties.vue